import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ClearClipBox, SetClipBox } from './clip-box.actions';
import { ClipBox } from './clip-box.models';

export interface ClipBoxStateModel {
  clipBox?: ClipBox;
}

const defaultState: ClipBoxStateModel = {};

@State<ClipBoxStateModel>({
  name: 'clipBoxState',
  defaults: defaultState,
})
@Injectable()
export class ClipBoxState {
  @Selector() static clipBox(state: ClipBoxStateModel): ClipBox | undefined {
    return state.clipBox;
  }

  @Action(SetClipBox) setClipBox(
    ctx: StateContext<ClipBoxStateModel>,
    { clipBox }: SetClipBox,
  ) {
    ctx.patchState({ clipBox });
  }

  @Action(ClearClipBox) clearClipBox(ctx: StateContext<ClipBoxStateModel>) {
    ctx.patchState({ clipBox: undefined });
  }
}
